import * as THREE from 'three';

// 墙面的环境贴图
export const textureLoaderWall = () => {
    //纹理贴图加载器TextureLoader
    const texLoader = new THREE.TextureLoader();
    // .load()方法加载图像，返回一个纹理对象Texture
    const texture = texLoader.load('/img/wall.jpg');
    return texture
}